// removed by extract-text-webpack-plugin
module.exports = {"pitLabel":"Syfjf","pitContainer":"apSGy","pitLabelCount":"_37vZR"};